"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMoistureLoadInputsMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.updateMoistureLoadInputsMutation = (0, graphql_tag_1.default) `
  mutation SaveMoistureLoadInputs(
    $moistureLoadinputs: MoistureLoadCalcInputType!
    $moistureLoadId: ID!
  ) {
    saveMoistureLoadInputs(
      inputSettings: $moistureLoadinputs
      moistureLoadId: $moistureLoadId
    ) {
      id
    }
  }
`;
//# sourceMappingURL=save-moisture-load-inputs.js.map